import { PostWhatsappBindResponse, WhatsappSetting } from "../interface/api/post-whatsapp-bind";

export const whatsappSettingMapper = {
  mapResponseToWhatsappSetting(
    response: PostWhatsappBindResponse
  ): WhatsappSetting {
    const { whatsappSetting } = response?.payload;
    return whatsappSetting;
  },
};
